import { render, staticRenderFns } from "./MaterialProgress.vue?vue&type=template&id=3cf27848&"
import script from "./MaterialProgress.vue?vue&type=script&lang=ts&"
export * from "./MaterialProgress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports